'use strict';

import React, { Component } from 'react'

import Link from '@Pure/Link'

import user_config from '@Config/Forms/user'

const { app, moment } = window;

const permissions_options = user_config.fields['permissions[title]'].options;

export default class UserRow extends Component
{
	render ()
	{
		const { data, blank=true, fields, ...props } = this.props;

		moment.locale('fr');

		const blank_props = blank === true
		? { target: '_blank', rel: 'noopener noreferrer' }
		: { };

		const link =
		(
			<Link className="u-link-only" { ...blank_props }
				href={ '/gestion-des-CE/membres/' + data.id }>
				<span className="u-readers-only">
					Voir l'utilisateur
				</span>
			</Link>
		);

		const user_permissions = permissions_options
		.find(opt => opt.value === data.permissions.title);

		let output =
		(
			<div className="c-dashboard__row">

				<div className="c-dashboard__cell User-email">

					{ data.login }

					{ link }

				</div>

				<div className="c-dashboard__cell User-firstname">

					{ data.firstname }

					{ link }

				</div>

				<div className="c-dashboard__cell User-lastname">

					{ data.lastname }

					{ link }

				</div>

				<div className="c-dashboard__cell User-EC">

					{ data._EC?.company }

					{ link }

				</div>

				<div className="c-dashboard__cell User-createdAt">

					{ moment(data.createdAt).format('DD/MM/YYYY') }

					{ link }

				</div>

				<div className="c-dashboard__cell User-validation_date">

					{
						data.validation_date
						? moment(data.validation_date).format('DD/MM/YYYY')
						: undefined
					}

					{ link }

				</div>

				<div className="c-dashboard__cell User-permissions_title">

					{ user_permissions?.label || user_permissions?.value }

					{ link }

				</div>

				<div className="c-dashboard__cell User-validation_status">

					{
						data.validation_status === 'validated' ?
						(
							<div className="c-status-indicator c-status-indicator--green">
								<div className="c-status-indicator__circle"></div>
								Activé
							</div>
						)
						: data.validation_status === 'pending' ?
						(
							<div className="c-status-indicator c-status-indicator--red">
								<div className="c-status-indicator__circle"></div>
								En attente
							</div>
						)
						: data.validation_status === 'new' ?
						(
							<div className="c-status-indicator c-status-indicator--blue">
								<div className="c-status-indicator__circle"></div>
								Récupéré
							</div>
						)
						: data.validation_status === 'imported' ?
						(
							<div className="c-status-indicator c-status-indicator--blue">
								<div className="c-status-indicator__circle"></div>
								En création
							</div>
						)
						: data.validation_status === 'disabled' ?
						(
							<div className="c-status-indicator">
								<div className="c-status-indicator__circle"></div>
								Désactivé
							</div>
						)
						: undefined
					}

					{ link }

				</div>

			</div>
		);

		return output;
	}
}